import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import React from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { FiChevronRight } from 'react-icons/fi'
import Flag from '../../../../../components/Template/Flag'
import { CountryCode, countryCodes } from '../../../../../i18n/countryCodes'
import mapCodeToLanguage from '../../../../../i18n/mappers/mapCodeToLanguage'
import Typography from '../components/Typography'
import Sidebar from '../Sidebar'
import withState from './withState'

function LanguageMenu({
  countryCode,
  switchLanguage,
}: WithTranslation & ILanguageMenu & ILanguageMenuDispatch) {
  const [open, setOpen] = React.useState<boolean>()

  function toggleOpen() {
    setOpen(!open)
  }

  function switchLang(code: CountryCode) {
    return function() {
      setTimeout(() => switchLanguage(code), 50)
    }
  }

  function countries() {
    return countryCodes.map(code => (
      <ListItem
        style={{ cursor: 'pointer' }}
        onClick={switchLang(code)}
        key={`lang-mobile-${code}`}
      >
        <ListItemIcon>
          <Flag countryCode={code} height={20} width={35} />
        </ListItemIcon>
        <ListItemText primary={mapCodeToLanguage(code)} />
      </ListItem>
    ))
  }

  return (
    <ListItem
      style={{
        backgroundColor: 'white',
        bottom: '0px',
        height: '60px',
        position: 'fixed',
      }}
      button={true}
      onClick={toggleOpen}
    >
      <ListItemIcon>
        <Flag countryCode={countryCode} height={20} />
      </ListItemIcon>
      <ListItemText
        primary={<Typography>{mapCodeToLanguage(countryCode)}</Typography>}
      />
      <FiChevronRight style={{ left: '276px', position: 'absolute' }} />
      <Sidebar
        closeDrawer={toggleOpen}
        open={open}
        elevation={0}
        headerIcon={<Flag countryCode={countryCode} height={20} />}
        headerLabel={mapCodeToLanguage(countryCode)}
        scrollable={true}
      >
        {countries()}
      </Sidebar>
    </ListItem>
  )
}

export default withTranslation()(withState(LanguageMenu) as any) as any

export interface ILanguageMenu {
  countryCode?: CountryCode
}

export interface ILanguageMenuDispatch {
  switchLanguage: (countryCode: CountryCode) => void
}
